/* angular:styles/component:css;d6e18c7c57afc68e6789166277193615620dfdadb07926cc41a052500c9212c5;/codebuild/output/src4169523549/src/friggkantine-admin/src/app/admin-dashboard/membership-v2/dialogs/ledger-dialog.component.ts */
.v2-ledger-bal {
  font-size: 13px;
  color: #666;
  font-weight: 400;
  margin-left: 8px;
}
.v2-ledger-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  min-width: 480px;
}
.v2-ledger-table th,
.v2-ledger-table td {
  text-align: left;
  padding: 6px 10px;
  border-bottom: 1px solid #eee;
}
.v2-ledger-table th {
  color: #888;
  font-weight: 600;
}
.v2-ledger-empty {
  color: #999;
  text-align: center;
  font-style: italic;
}
.v2-tx {
  border-radius: 10px;
  padding: 1px 8px;
  font-size: 11px;
  text-transform: capitalize;
}
.v2-tx.credit {
  background: #e6f4ea;
  color: #1e7e34;
}
.v2-tx.debit {
  background: #fdecea;
  color: #b3261e;
}
/*# sourceMappingURL=ledger-dialog.component.css.map */
